export default __webpack_public_path__ + "static/media/marcel_hallensleben.fb0386ef.webp";